import React from 'react';
import { Modal, View, Text, TouchableOpacity, FlatList, StyleSheet } from 'react-native';

import { t } from '../../i18n/translations';
import PrimaryButton from '../../shared/ui/PrimaryButton';
import { useLanguageStore } from '../quiz-core/languageStore';

interface Member {
  user_id: string;
  user_profiles?: { name?: string; avatar_url?: string };
  role: string;
}

interface FriendsMembersModalProps {
  visible: boolean;
  onClose: () => void;
  members: Member[];
  currentUserId: string;
  isAdmin: boolean;
  onMakeAdmin?: (userId: string) => void;
}

const FriendsMembersModal: React.FC<FriendsMembersModalProps> = ({
  visible,
  onClose,
  members,
  currentUserId,
  isAdmin,
  onMakeAdmin,
}) => {
  const { language } = useLanguageStore();
  return (
    <Modal visible={visible} transparent animationType="fade" onRequestClose={onClose}>
      <View style={styles.overlay}>
        <View style={styles.modalContent}>
          <Text style={styles.title}>{t('familiesFriends.titleFriendsMembers', language)}</Text>
          <FlatList
            data={members}
            keyExtractor={(item) => item.user_id}
            renderItem={({ item }) => (
              <View style={styles.memberRow}>
                <Text style={styles.memberName}>{item.user_profiles?.name || 'Unknown'}</Text>
                <Text style={styles.memberRole}>
                  {item.role === 'owner' ? t('familiesFriends.roleOwner', language) : item.role === 'admin' ? t('familiesFriends.roleAdmin', language) : t('familiesFriends.roleMember', language)}
                </Text>
                {isAdmin && item.role !== 'owner' && item.user_id !== currentUserId && (
                  <TouchableOpacity
                    style={styles.makeAdminBtn}
                    onPress={() => onMakeAdmin && onMakeAdmin(item.user_id)}
                  >
                    <Text style={styles.makeAdminText}>{t('familiesFriends.buttonMakeAdmin', language)}</Text>
                  </TouchableOpacity>
                )}
              </View>
            )}
          />
          <PrimaryButton title={t('familiesFriends.buttonClose', language)} onPress={onClose} style={{ marginTop: 18 }} />
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.5)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContent: {
    backgroundColor: '#fff',
    borderRadius: 12,
    padding: 24,
    minWidth: 300,
    maxWidth: 340,
    width: '90%',
    alignItems: 'center',
  },
  title: {
    fontSize: 22,
    fontWeight: 'bold',
    marginBottom: 16,
    color: '#222',
  },
  memberRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 10,
    width: '100%',
  },
  memberName: {
    fontSize: 16,
    color: '#333',
    flex: 1,
  },
  memberRole: {
    fontSize: 15,
    color: '#888',
    marginLeft: 10,
    marginRight: 10,
    minWidth: 70,
    textAlign: 'right',
  },
  makeAdminBtn: {
    backgroundColor: '#3381c6',
    borderRadius: 6,
    paddingHorizontal: 10,
    paddingVertical: 4,
  },
  makeAdminText: {
    color: '#fff',
    fontWeight: 'bold',
    fontSize: 13,
  },
});

export default FriendsMembersModal;
